import { formatPhoneNumber } from "@/lib/phoneHelpers";
import type { FacilitySearchResult } from "../queries";

export function formatFacilityPhone(row: FacilitySearchResult): string | null {
  if (!row.phone?.phoneNumber) return null;

  let phoneToFormat = row.phone.phoneNumber;

  if (row.phone.phoneCountry && row.phone.phoneCountry !== "US" && !phoneToFormat.startsWith("+")) {
    phoneToFormat = `+${phoneToFormat}`;
  }

  const phoneWithExtension = row.phone.phoneExtension
    ? `${phoneToFormat} ext ${row.phone.phoneExtension}`
    : phoneToFormat;

  return formatPhoneNumber(phoneWithExtension);
}
